import { toast } from 'react-toastify';


const showToast = (type, message) => {
  toast(message, {
    type: type,
    toastId: "singleToast",
    autoClose: 1000,
    hideProgressBar: false,
  });
};

export default showToast;